import { useEffect, useState } from "react";
import expicon from "../Assets/expicon.png"

const ImageContent=({url1, url2, url3,swiper,setSwiper,zoomimage,setzoomimage,handleclick})=>
{
    // const [isZoomed, setIsZoomed] = useState({1:false,2:false,3:false})
    // const [zoomed, setZoomed] = useState({1:false,2:false,3:false})
    
    
    // const setfullscreen=()=>
    // {
    //     setzoomimage(true)
    //     // swiper.autoplay.stop()
    //     // zoomed[1]||zoomed[2]||zoomed[3]?swiper.autoplay.start():swiper.autoplay.stop()
    // }
    
    
    
    return(
        <div className={` w-[100%] flex justify-center gap-[15px] cursor-pointer h-[500px]`}>
           <div className="flex justify-center items-center h-[500px] w-[70%]">
                <img id="image1"  className="h-full w-full object-cover" src={url1}/>
           </div>
           
           <div className="grow flex flex-col gap-[15px] h-[500px] w-[30%]">
                <div className="h-[243px]"> 
                    <img id="image2" className="h-full w-full object-cover" src={url2}/>
                </div>
                <div className="h-[243px] relative">
                    <img id="image3" className="h-full w-full object-cover " src={url3}/>   
                    <div className="flex justify-end mr-[2px]">
                        <div id='activeeffect' className="absolute flex gap-[10px] items-center top-[73%] px-[9px] py-[15px] bg-black/[.56] backdrop-opacity-10" onClick={handleclick}>
                            <p className="text-[15px] text-white font-[500] leading-[30px]">View All</p>
                            <img src={expicon}/>
                        </div>
                    </div>
                </div>
           </div>
        </div>
    )
}
export default ImageContent

// w-[550px] h-[415px]